import React, { FC, memo, useEffect, useState } from 'react';
import { box } from 'tweetnacl';
import { decrypt } from '../../util/crypto';
import { decodeBase64 } from 'tweetnacl-util';
import { formatTimeOrRelative } from '../../util/date-utils';
import i18next from 'i18next';
import emoji from 'to-emoji';
import ErrorIcon from '../../assets/error-icon.svg?react';
import { useChat } from '../../contexts/chat-context';

type Props = {
  message: any, therapist: any,
  resendMessage: (text: string) => void;
};

const ChatMessage: FC<Props> = ({ message, therapist, resendMessage }) => {
  const { tKeyPair, patientPublicKey } = useChat();
  const [isTimeoutReached, setTimeoutReached] = useState(false);
  const messageClass = message && message.senderId === therapist._id ? 'right' : 'left';
  
  if (!patientPublicKey || !tKeyPair) {
    return null;
  }
  
  const finalKeyTherapist = box.before(decodeBase64(patientPublicKey), tKeyPair.secretKey);

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeoutReached(true);
    }, 5000);

    return (): void => clearTimeout(timer);
  }, [message.ackId]);
    
  if (messageClass === 'left') {
    return (
      <div className={`chat-message-${messageClass} pb-4`} >
        <div className={`flex-shrink-1 chat-bg-${messageClass} chat-round py-2 px-3 me-3 w-100 clearfix`} >

          <p 
            className="mt-1 p-0 mb-0" 
            dangerouslySetInnerHTML={{ __html: emoji.emoticonToEmoji(decrypt(finalKeyTherapist, message.text)) }}>
          </p>
          <p className="small text-nowrap mt-0 p-0 mb-0 text-end">
            {formatTimeOrRelative(message.createdAt)}
          </p>
        </div>
      </div>);
  } else {
    return (
      <>
        <div 
          className={`chat-message-${messageClass} mt-3`} 
          onClick={() => { if (message.ackId) {resendMessage(decrypt(finalKeyTherapist, message.text));} }}>
          <div className={`flex-shrink-1 chat-bg-${messageClass} chat-round py-2 px-3 me-3 w-100 clearfix
                    ${message.ackId && isTimeoutReached ? 'chat-bg-right-discard' : ''}`}>
            <p 
              className="mt-1 p-0 mb-0" 
              dangerouslySetInnerHTML={{ __html: emoji.emoticonToEmoji(decrypt(finalKeyTherapist, message.text)) }}>
            </p>
            <p className="small text-nowrap mt-0 p-0 mb-0 text-end">
              {formatTimeOrRelative(message.createdAt)}
              {message.ackId && !isTimeoutReached ? <span><i className="fas fa-spin fa-spinner chat-date-loading ms-2" /></span> : null}</p>
          </div>
          {message.ackId && isTimeoutReached ?
            <div className={'chat-message-error text-end me-4'}>
              <p className={'small text-nowrap text-primary mt-0 p-0 mb-0 w-100 '}> {i18next.t('chat.sendingFailed')}
                <ErrorIcon className='small' width={12} height={12} />
              </p>
            </div> : null}
        </div>
      </>);
  }
};

export default memo(ChatMessage);
